// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"a118caf3","325":"70def9f3","531":"50f07897","599":"70def9f3"}[chunkId] + ".chunk.css";
};